<template>
  <el-card>
    <el-page-header @back="$router.push({ name: 'pdv.authorization.reverse' })" title
      content="Lista de Pendências de Autorizações"></el-page-header>
    <br />
    <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px" :inline="true"
      v-if="userType === '1'">
      <el-row :gutter="5">
        <el-col :xs="12" :sm="6" :md="6" :lg="12" :xl="12">
          <el-form-item :label="$t('licenca')" prop="licence" class="is-required" v-if="userType === '1'">
            <CustomerList v-model="ruleForm.customer" :customerType="2" :multiple="false" />
          </el-form-item>
          <el-button size="mini" type="info" @click="fetch()">Filtrar</el-button>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <el-table ref="tableData" :data="tableList" size="small" stripe>
      <el-table-column prop="callId" :label="$t('atendimento')" />
      <el-table-column prop="userName" :label="$t('atendente')" />
      <el-table-column prop="name" :label="$t('cliente')" />
      <el-table-column prop="authorization" :label="$t('autorizacao')" />
      <el-table-column prop="tag" :label="$t('etiqueta')">
        <template slot-scope="scope">
          <el-input v-model="scope.row.tag" maxlength="13" class="uppercase"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="success" autofocus @click="save()">{{
      $t("salvar")
    }}</el-button>
  </el-card>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import { PdvService } from "@/services/pdv/pdv.services";
import { i18n } from "@/plugin/i18n";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
export default {
  components: {
    CustomerList,
  },
  data() {
    return {
      userType: '2',
      tableList: [],
      ruleForm: {
        customer: '',
      }
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((user) => {
        vm.userType = user.type;
        if (vm.userType !== '1') {
          vm.fetch();
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
          offset: 45,
        });
      });
  },
  methods: {
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PdvService.pendencies(vm.ruleForm.customer)
        .then((response) => {
          vm.tableList = response.data;
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
        .finally(() => loading.close());
    },
    save() {
      const vm = this;
      if (vm.tableList.filter(x => x.tag).length === 0) {
        return vm.$message({ type: "error", duration: 5000, message: 'É preciso informar ao menos uma etiqueta', offset: 45 })
      }
      PdvService.down(vm.tableList.filter(x => x.tag).map((x) => {
        return {
          id: x.id,
          tag: x.tag,
        }
      }))
        .then((response) => {
          vm.fetch();
          vm.$message({
            type: "success",
            duration: 5000,
            message: 'Etiquetas atualizadas com sucesso!',
            offset: 45,
          });
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error, offset: 45, }))
        .finally(() => loading.close());
    },
  }
}
</script>